import { render, staticRenderFns } from "./AutoLogin.vue?vue&type=template&id=fb6a0462&scoped=true&lang=pug&"
import script from "./AutoLogin.vue?vue&type=script&lang=js&"
export * from "./AutoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a0462",
  null
  
)

export default component.exports